import { QuickViewBilling } from '@models';

export function formatBalanceLabel(
  billing: QuickViewBilling | null,
  formatAmount: (dollars: number) => string
): string {
  if (billing === null) {
    return '';
  }

  if (!billing.hasAnyInvoices) {
    return 'No invoices';
  }

  if (billing.balanceDueCents <= 0) {
    return 'No balance due';
  }

  return `${formatAmount(billing.balanceDueCents / 100)} balance due`;
}

export function hasBalanceDue(billing: QuickViewBilling | null): boolean {
  return (
    billing !== null && billing.hasAnyInvoices && billing.balanceDueCents > 0
  );
}
